import React from "react";
import { useState, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';

import SearchBar from "./common/SearchBar";

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';


export default function FormCreate(){


  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();

  const [formError, setFormError] = useState(false)
  const [formWarning, setFormWarning] = useState(false)
  const [formCode, setFormCode] = useState("")


  const handleChange = (event) => {
    let code = event.target.value;
    setFormCode(code);
  };


  const handleSubmit = (event) => {
    event.preventDefault(); // Предотвращаем перезагрузку страницы

    let data = {form_code: formCode};


    axios_api.post(api_url + `/manage_form/`, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        console.log("Form created");
        if (result.data?.visible_to_user === false) {
          setFormError(false);
          setFormWarning(`Форма ${formCode} создана, но её раздел не закреплён за вами, поэтому в списке форм её не будет. Обратитесь к администратору.`);
          return;
        }
        navigate("/form_list");
        navigate(0);
      },
      (error) => {
        setFormWarning(false)
        setFormError(error.response.data)

        console.log(error);
      }
    );
  }

  return (
    <>
      <div className="row">
        <h3 className="m-3">Создать форму</h3>
      </div>
      <div className='m-3'>
        <div className="lk-form">
          <form onSubmit={handleSubmit}>
            <div className="input-group mt-3 mb-2">
              <label className="">
                <p>введите код формы в 1С</p> 
                <input id="form_code" type="text" className="form-control"  value={formCode} onChange={handleChange}></input>
              </label>
            </div>

            { formError &&
              <p className="text-danger">{formError}</p>
            }

            { formWarning &&
              <div className="alert alert-warning" role="alert">{formWarning}</div>
            }
            
            <button type="submit" className="btn lk-button my-3">Создать</button>

          </form>
        </div>               
      </div> 
    </>
  )
}
